export const EFFECTIVE_DATE = "04-04-2026";
